import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
const ProjectDetailsTopPageData = _ref => {
  let {
    projectDetails,
    isVersion8,
    updateState
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('bsfz_number')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, projectDetails.bsfz_number)), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('full_project_name')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, projectDetails.project_elster_detail.claim_project_report.full_project_name)), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('start_of_work')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(DatePicker, {
    selected: projectDetails.project_start_date,
    disabled: true
  }))), isVersion8 && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('date_of_certification')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(DatePicker, {
    selected: projectDetails.current_bsfz_response_date,
    disabled: true
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('information_declared_has_not_changed')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "information_declared_has_not_changed",
    value: projectDetails.information_declared_has_not_changed,
    onChange: e => updateState(e, projectDetails, 'information_declared_has_not_changed'),
    options: [{
      key: 'information_declared_has_not_changed_yes',
      value: 'true',
      text: 'yes'
    }, {
      key: 'information_declared_has_not_changed_no',
      value: 'false',
      text: 'no'
    }],
    dataTestId: "information_declared_has_not_changed",
    passEntireEvent: true,
    dropdownStyle: {
      minWidth: '100%'
    }
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('further_funding_granted')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "further_funding_granted",
    value: projectDetails.further_funding_granted,
    onChange: e => updateState(e, projectDetails, 'further_funding_granted'),
    options: [{
      key: 'further_funding_granted_yes',
      value: 'true',
      text: 'yes'
    }, {
      key: 'further_funding_granted_no',
      value: 'false',
      text: 'no'
    }],
    dataTestId: "further_funding_granted",
    passEntireEvent: true,
    dropdownStyle: {
      minWidth: '100%'
    }
  }))));
};
export default ProjectDetailsTopPageData;